import { Space } from "antd";
import { setPage } from "../../state/slices/generalSlice";
import { useDispatch } from "react-redux";

import "../../styles/layout/pivotHeader.scss";

const PivotHeader = () => {
  const dispatch = useDispatch();

  return (
    <div className="header-items">
      <Space
        style={{ color: "black", fontWeight: 600, height: "100%", gap: 0 }}
      >
        <span
          className="pivot-header-title"
          onClick={() => dispatch(setPage("dashboard"))}
        >
          PIVOT:
        </span>
        <span
          className="long-name pivot-header-subtitle"
          onClick={() => dispatch(setPage("dashboard"))}
        >
          Platform for Information, Visibility, and Organizational Tasks
        </span>
      </Space>
    </div>
  );
};

export default PivotHeader;
